import api from "src/apis/api"

// Global command-palette search across leads, deals, contacts, bookings and
// projects (scoped server-side to the user's org + account type).
export async function globalSearch(query, { signal } = {}) {
  const { data } = await api.get("/api/v1/search", {
    params: { q: query },
    signal,
  })
  return data.results || []
}
